export const LicenceCheckingSharedData = {
    getPermissions() {
        return [
            {
                id: 1,
                role: "Purchase Credits",
                description:
                    "Allows the user to purchase credits via PO number or over the phone.",
                selected: false,
            },
            {
                id: 2,
                role: "Perform Checks",
                description:
                    "Allows the user to perform manual checks from the licence checking pages and employee profile.",
                selected: false,
            },
            {
                id: 3,
                role: "Access Grey Fleet",
                description:
                    "Allows the user to view and manage grey fleet checks.",
                selected: false,
            },

        ];
    }
}